<template>
  <div>
    <b-card title="Genel Bilgiler">
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <product-files-title-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <PFDocumentGroupsSelectCard />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <product-files-notes-card />
        </b-col>
      </b-row>
    </b-card>
    <b-card title="Doküman Bilgileri">
      <b-row>
        <template v-if="controlProductFileVersions">
          <b-col
            v-if="dataItem.id"
            cols="12"
            md="12"
          >
            <PFilesVOVTSelectCard />
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <PFVOBriefDescriptionCard />
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <PFVORelaseNotesCard />
          </b-col>
          <b-col
            v-if="dataItem.id"
            cols="12"
            md="12"
          >
            <PFilesVOStatusSelectCard />
          </b-col>
        </template>
        <b-col
          cols="12"
          md="12"
        >
          <product-files-file-card />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import ProductFilesTitleCard from '@/views/Products/Files/Elements/TitleCard.vue'
import PFDocumentGroupsSelectCard from '@/views/Products/Files/Elements/DocumentGroupsCard.vue'
import ProductFilesNotesCard from '@/views/Products/Files/Elements/NotesCard.vue'
import PFilesVOVTSelectCard from '@/views/Products/Files/Elements/VersionOptions/VersionTypeSelect.vue'
import PFVOBriefDescriptionCard from '@/views/Products/Files/Elements/VersionOptions/BriefDescription.vue'
import PFVORelaseNotesCard from '@/views/Products/Files/Elements/VersionOptions/ReleaseNotes.vue'
import ProductFilesFileCard from '@/views/Products/Files/Elements/FileCard.vue'
import PFilesVOStatusSelectCard from '@/views/Products/Files/Elements/VersionOptions/StatusSelect.vue'

export default {
  name: 'ProductFilesItemForm',
  components: {
    PFilesVOStatusSelectCard,
    ProductFilesFileCard,
    PFVORelaseNotesCard,
    PFVOBriefDescriptionCard,
    PFilesVOVTSelectCard,
    ProductFilesNotesCard,
    PFDocumentGroupsSelectCard,
    ProductFilesTitleCard,
    BCard,
    BRow,
    BCol,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['productFiles/dataItem']
    },
    controlProductFileVersions() {
      // userData içindeki packageLimits array'inde subject'i SERVICE_FILE_VERSIONS olan elemanın limit'i 1 ise true, değilse false döndürür
      if (
        this.userData
          && Array.isArray(this.userData.packageLimits)
      ) {
        const found = this.userData.packageLimits.find(
          item => item.subject === 'PRODUCT_FILE_VERSIONS',
        )
        return found && found.limit === 1
      }
      return false
    },
  },
}
</script>
